import calendar from "../assets/website/Immagine 2022-08-13 134848.jpg";
import bank from "../assets/website/Immagine 2022-08-13 135627.jpg";
import websiteGreen from "../assets/website/Immagine 2022-08-13 135758.jpg";
import universe from "../assets/website/universe.jpg";
import socialfake from "../assets/website/socialfake.jpg";
import oldPortfolio from "../assets/website/oldportfolio.jpg";
import todolist from "../assets/website/todolist.jpg";

const ListPhoto = [
  {
    thumbnail: calendar,
    original: calendar,
  },
  {
    thumbnail: websiteGreen,
    original: websiteGreen,
  },
  {
    thumbnail: universe,
    original: universe,
  },
  {
    thumbnail: socialfake,
    original: socialfake,
  },
  {
    thumbnail: bank,
    original: bank,
  },
  {
    thumbnail: oldPortfolio,
    original: oldPortfolio,
  },
  {
    thumbnail: todolist,
    original: todolist,
  },
];

export { ListPhoto };
